import type {VendorLogisticsChangeRequest} from './_requests'

export type VendorLogisticsRequestMaps = {
  byPurchaseOrderId: Map<number, VendorLogisticsChangeRequest>
  byQuotationId: Map<number, VendorLogisticsChangeRequest>
  byRfqId: Map<number, VendorLogisticsChangeRequest>
}

export function buildVendorLogisticsRequestMaps(
  requests: VendorLogisticsChangeRequest[]
): VendorLogisticsRequestMaps {
  const byPurchaseOrderId = new Map<number, VendorLogisticsChangeRequest>()
  const byQuotationId = new Map<number, VendorLogisticsChangeRequest>()
  const byRfqId = new Map<number, VendorLogisticsChangeRequest>()

  requests.forEach((request) => {
    const purchaseOrderId = Number(request.purchaseOrderId)
    if (Number.isFinite(purchaseOrderId)) byPurchaseOrderId.set(purchaseOrderId, request)
    const quotationId = Number(request.quotationId)
    if (Number.isFinite(quotationId)) byQuotationId.set(quotationId, request)
    const rfqId = Number(request.rfqId)
    if (Number.isFinite(rfqId)) byRfqId.set(rfqId, request)
  })

  return {byPurchaseOrderId, byQuotationId, byRfqId}
}

export function hasChangedVendorLogisticsValue(
  oldValue: number | null | undefined,
  requestedValue: number | null | undefined
): boolean {
  return Number(oldValue ?? 0) !== Number(requestedValue ?? 0)
}
